import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  model: {
    src: "https://modelviewer.dev/shared-assets/models/glTF-Sample-Models/2.0/DamagedHelmet/glTF-Binary/DamagedHelmet.glb",
    type: "glb",
  },
};

export const ModelSlice = createSlice({
  name: "model",
  initialState,
  reducers: {
    setSrc: (state, action) => void (state.model = action.payload),
  },
});

export const { setSrc } = ModelSlice.actions;
export default ModelSlice.reducer;
